import http from "app/services/httpService";

import config from "config.json";

const { apiUrl } = config;

const addBanks = async (values) => {
  try {
    const { data } = await http.post(`${apiUrl}/masterbanks`, values);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getBankLists = async () => {
  try {
    const { data } = await http.get(
      `${apiUrl}/masterbanks/masteradminbanklist`
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

const bankUpdates = async (id, value) => {
  try {
    const { data } = await http.post(
      `${apiUrl}/masterbanks/update/${id}`,
      value
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

const exportVirtualBankList = async (queryString) => {
  try {
    const url = `${apiUrl}/virtualbank/virtual-transaction-list/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await http.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

export { addBanks, getBankLists, bankUpdates, exportVirtualBankList };
